/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metrics_Font_Size_HelpInputs */

const en_options_metrics_font_size_help = /** @type {(inputs: Options_Metrics_Font_Size_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set the font size (in pixels) of the metrics shown on each event in the editor list.`)
};

const fr_options_metrics_font_size_help = /** @type {(inputs: Options_Metrics_Font_Size_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set the font size (in pixels) of the metrics shown on each event in the editor list.`)
};

const de_options_metrics_font_size_help = /** @type {(inputs: Options_Metrics_Font_Size_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set the font size (in pixels) of the metrics shown on each event in the editor list.`)
};

const it_options_metrics_font_size_help = /** @type {(inputs: Options_Metrics_Font_Size_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set the font size (in pixels) of the metrics shown on each event in the editor list.`)
};

const ru_options_metrics_font_size_help = /** @type {(inputs: Options_Metrics_Font_Size_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set the font size (in pixels) of the metrics shown on each event in the editor list.`)
};

const es_options_metrics_font_size_help = /** @type {(inputs: Options_Metrics_Font_Size_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set the font size (in pixels) of the metrics shown on each event in the editor list.`)
};

const zh_cn2_options_metrics_font_size_help = /** @type {(inputs: Options_Metrics_Font_Size_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set the font size (in pixels) of the metrics shown on each event in the editor list.`)
};

const ja_options_metrics_font_size_help = /** @type {(inputs: Options_Metrics_Font_Size_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set the font size (in pixels) of the metrics shown on each event in the editor list.`)
};

const hi_options_metrics_font_size_help = /** @type {(inputs: Options_Metrics_Font_Size_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set the font size (in pixels) of the metrics shown on each event in the editor list.`)
};

const pt_pt2_options_metrics_font_size_help = /** @type {(inputs: Options_Metrics_Font_Size_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set the font size (in pixels) of the metrics shown on each event in the editor list.`)
};

/**
* | output |
* | --- |
* | "Set the font size (in pixels) of the metrics shown on each event in the editor list." |
*
* @param {Options_Metrics_Font_Size_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metrics_font_size_help = /** @type {((inputs?: Options_Metrics_Font_Size_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metrics_Font_Size_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_metrics_font_size_help(inputs)
	if (locale === "de") return de_options_metrics_font_size_help(inputs)
	if (locale === "it") return it_options_metrics_font_size_help(inputs)
	if (locale === "ru") return ru_options_metrics_font_size_help(inputs)
	if (locale === "es") return es_options_metrics_font_size_help(inputs)
	if (locale === "zh-CN") return zh_cn2_options_metrics_font_size_help(inputs)
	if (locale === "ja") return ja_options_metrics_font_size_help(inputs)
	if (locale === "hi") return hi_options_metrics_font_size_help(inputs)
	if (locale === "pt-PT") return pt_pt2_options_metrics_font_size_help(inputs)
	return en_options_metrics_font_size_help(inputs)
});